export const sourceSystems = {
    picsy: 'picsy'
};